// @flow

import { connect } from 'react-redux';
import AIChatPage from '../components/pages/ai-chat';

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(AIChatPage);
